import { createFileRoute, redirect } from "@tanstack/react-router";
import { splitSlug } from "@/lib/utils";

export const Route = createFileRoute("/novel/$slug")({
  loader: async ({ params }) => {
    const { id, slug } = splitSlug(params.slug || "");
    if (id && slug) {
      throw redirect({
        to: "/novel/$id/$slug",
        params: { id, slug },
      });
    }
  },
});
